import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/LastOptions";

const LastOptions: React.FC = () => {
  const { optionsZustand } = useCombinedStore();

  const lastPagesOption = optionsZustand.find(
    (option) => option.optionType === "lastPages"
  );

  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>history</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Últimas opções acessadas</AlfredoStyles.Title>
        <AlfredoStyles.LastPagesContainer>
          {lastPagesOption &&
            lastPagesOption.optionInfo
              .filter((info, index) => index % 3 === 0)
              .reverse()
              .map((info) => {
                const path = info.value;
                const title = lastPagesOption.optionInfo.find(
                  (i) => i.id === `${path}_title`
                )?.value;
                const icon = lastPagesOption.optionInfo.find(
                  (i) => i.id === `${path}_icon`
                )?.value;

                return (
                  <AlfredoStyles.PageItem to={path} key={path}>
                    <AlfredoStyles.PageIcon>{icon}</AlfredoStyles.PageIcon>
                    <AlfredoStyles.PageTitle>{title}</AlfredoStyles.PageTitle>
                  </AlfredoStyles.PageItem>
                );
              })}
        </AlfredoStyles.LastPagesContainer>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
